module.exports = __webpack_public_path__ + "assets/img/logo.85da2c2c.png";